import { useMutation } from '@northladder/services';
import {
  ErrorEventsEnum,
  errorLogToRemoteUtil,
  IApiError,
} from '@northladder/utilities';

import { USER_REGISTRATION_API } from '../userRegistrationAPIClient';
import { IDeleteAccountResponse } from '../types';

/**
 * This is to track the account deletion mutation keys in react query cache.
 */
const MUT_DELETE_ACCOUNT = 'delete-account-mutation-key';

/**
 * The useDeleteAccountMutation Props
 */
export interface IUseDeleteAccountOptions {
  /**
   * Callback on a successful account deletion request.
   */
  onSuccessCallback: (data: IDeleteAccountResponse) => void;
  /**
   * Callback on a failed account deletion request.
   */
  onErrorCallback: (err: IApiError) => void;
}

/**
 * This performs an account deletion request.
 *
 * @param IUseDeleteAccountOptions
 */
export const useDeleteAccountMutation = ({
  onSuccessCallback,
  onErrorCallback,
}: IUseDeleteAccountOptions) => {
  const { mutate, isPending, error } = useMutation({
    mutationKey: [MUT_DELETE_ACCOUNT],
    networkMode: 'always',
    mutationFn: USER_REGISTRATION_API.deleteAccount,
    onSuccess: (data: IDeleteAccountResponse) => {
      onSuccessCallback(data);
    },
    onError: (err: IApiError) => {
      errorLogToRemoteUtil({
        error: err,
        errorCode: ErrorEventsEnum.ERROR_IN_API_CALL,
        errorTitle: 'Account Deletion Error',
        message: err?.message,
      });
      onErrorCallback(err);

      return err;
    },
  });

  return {
    error,
    isPending,
    callDeleteAccount: mutate,
  };
};
